import request from '@/utils/request'
// 检验手机号
export function payRecharge(data) {
    return request({
        url:'/netbar/api/order/v1/get_recharge_position',
        method:'post',
        data
    })
}
// 请求支付
// export function pay(data) {
//     return request({
//         url:'/netbar/api/order/v1/wxPay',
//         method:'post',
//         data
//     })
// }
//拉起银行支付
export function pay(data) {
    return request({
        url:'/netbar/api/order/v1/cardPay',
        method:'post',
        data
    })
}
// 拉起微信支付
export function payState(data) {
    return request({
        url:'/netbar/api/order/v1/select_information',
        method:'post',
        data
    })
}